export enum SkipType {
  Free = 0,
  Radio = 1,
  Multiple = 2,
  Scale = 3,
  Description = 4,
  Matrix = 5
}
